module.exports = __webpack_public_path__ + "static/media/odometer.b967aebf.svg";